<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div id="page-accordion" [formGroup]="formGroup">
      <div class="card" [ngClass]="active_table === 'customer' ? 'active' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('customer')">
          <h4 class="mb-0">{{ "CUSTOMER" | translate }}</h4>
        </div>
        <div class="card-body" *ngIf="active_table === 'customer'">
          <div class="row">
            <div class="col-lg-2 col-12">
              <app-form-customer-logo-upload [customer]="{}" (change)="logoBase64 = $event"></app-form-customer-logo-upload>
            </div>
            <div class="row col-lg-10 col-12">
              <div class="form-group col-12">
                <label for="name">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="name" class="form-control {{ fieldHasErrors('name') ? 'is-invalid' : '' }}" formControlName="name" required maxlength="150" />
                <div class="invalid-feedback" *ngIf="formGroup.controls?.name?.errors?.required">{{ "ERRORS.FIELD_COMPANY" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.name?.errors?.minLength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.name?.errors?.maxLength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="subject_type">{{ "MENU.CUSTOMERS_TYPE_SINGULAR" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select (change)="changeSubjectType()"
                  id="subject_type"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="subject_type"
                  [multiple]="false"
                  [searchable]="false"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="subjectTypeList"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.subject_type.errors?.required">{{ "ERRORS.FIELD_SUBJECT_TYPE" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="country"
                  bindLabel="name"
                  bindValue="code"
                  formControlName="country"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="nationsWithCodes"
                ></ng-select>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="email">{{ "EMAIL" | translate }}</label>
                <input type="text" id="email" class="form-control" formControlName="email" [ngClass]="{'is-invalid': formGroup.controls.email.errors!==null}" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.pec.errors!==null">{{ "ERRORS.INSERT_VALID_EMAIL" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="pec">{{ "PEC" | translate }}</label>
                <input type="text" id="pec" class="form-control" formControlName="pec" [ngClass]="{'is-invalid': formGroup.controls.pec.errors!==null}" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.pec.errors!==null">{{ "ERRORS.INSERT_VALID_EMAIL" | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fatturazione -->
      <div class="card" [ngClass]="{'active pb-0': active_table === 'invoice'}">
        <div class="card-title px-2 mb-0" (click)="changeTab('invoice')">
          <h4 class="mb-0">{{ "CUSTOMERS_INVOICE_DATA" | translate }}</h4>
        </div>
        <div class="card-body pb-0 row" *ngIf="active_table === 'invoice'">
          <div *ngFor="let item of fieldsInvoice" class="form-group col-12" [ngClass]="'col-lg-'+(item.col_lg||6)">
            <label [for]="item.key">{{ item.key.toUpperCase() | translate }}<sup *ngIf="item.validators?.required" class="text-danger">*</sup></label>
            <ng-container [ngSwitch]="item.type">
              <ng-select *ngSwitchCase="'select'" [id]="item.key" [formControlName]="item.key" [searchable]="item.searchable || true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true"
                         [ngClass]="{'is-invalid': fieldHasErrors(item.key)}">
                <ng-option *ngFor="let element of (item.values || [])" [value]="element.value">{{ element.label | translate }}</ng-option>
              </ng-select>
              <input *ngSwitchCase="'date'" type="date" [id]="item.key" class="form-control" [formControlName]="item.key" [ngClass]="{'is-invalid': fieldHasErrors(item.key)}" />
              <input *ngSwitchDefault [type]="item.type" [id]="item.key" class="form-control" [formControlName]="item.key" [maxlength]="item.max" [ngClass]="{'is-invalid': fieldHasErrors(item.key)}"
                     [placeholder]="item.placeholder || ''" />
            </ng-container>
            <ng-container *ngIf="item.validators">
              <div class="invalid-feedback" *ngIf="formGroup.controls[item.key]?.errors?.required">{{ "ERRORS.FIELD_REQUIRED" | translate }}</div>
              <div class="invalid-feedback" *ngIf="formGroup.controls[item.key]?.errors?.minlength">{{ "MIN" | translate }} {{ item.validators.minLength }} {{ "CHARACTERS" | translate }}</div>
              <div class="invalid-feedback" *ngIf="formGroup.controls[item.key]?.errors?.maxlength">{{ "MAX" | translate }} {{ item.validators.maxLength }} {{ "CHARACTERS" | translate }}</div>
            </ng-container>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-12 text-right">
        <button class="btn btn-primary text-primary" (click)="add()">{{ "ADD" | translate }}</button>
      </div>
    </div>

  </div>
</div>
